import { baseTokenVars, semanticTokenVars } from '@tundr/ds-tokens';

/**
 * Ordered palette of CSS variable references for chart segments.
 * These resolve to `var(--xxx)` strings at build-time —
 * use `useChartColors` to resolve them to actual hex values for canvas.
 */
export const chartSegmentColors = [
  semanticTokenVars.accent.indaco.default.subtle,
  baseTokenVars.color.orange['300'],
  baseTokenVars.color.sage['500'],
  semanticTokenVars.accent.yellow.default.subtle,
  baseTokenVars.color.denim['300'],
  baseTokenVars.color.sage['300'],
  baseTokenVars.color.yellow['700'],
] as const;

/** Structural color refs used by chart axes, tooltips, legends, etc. */
export const chartStructuralColors = {
  axisLabel: semanticTokenVars.content.muted.default,
  axisLine: semanticTokenVars.border.neutral.default.subtle,
  tooltipBackground: semanticTokenVars.surface.background.neutral.default.base,
  tooltipText: semanticTokenVars.content.default.default,
  legendText: semanticTokenVars.content.muted.default,
  donutTrack: semanticTokenVars.surface.background.neutral.default.raised,
  donutProgress: semanticTokenVars.accent.green.default.subtle,
} as const;
